import { forwardRef, useImperativeHandle, useRef } from "react";
import { PropertyRow } from "../PropertyUpdateRowInput";
import { TextBox } from "@etframework/ui.components";

export const TextboxUpdateInput = forwardRef(
  ({ change, field, settings, onRemove, value = "", id }, ref) => {
    const compRef = useRef(null);

    useImperativeHandle(ref, () => ({
      focus: () => compRef.current?.getComponentRef()?.focusIn(),
      applyValue: (properties) => {
        const value = compRef.current.getValue();
        if (value) properties[field] = value;
      },
      getValue: () => ({
        field: field,
        value: compRef.current?.getValue(),
        hasValue: !!compRef.current?.getValue(),
        settings: settings,
      }),
    }));

    return (
      <PropertyRow
        key={field}
        field={field}
        label={settings?.headerText}
        onRemove={onRemove}
        settings={settings}
      >
        <TextBox
          className={"w-100"}
          id={id}
          value={value}
          ref={compRef}
          change={change}
        />
      </PropertyRow>
    );
  }
);
